.follow-up-questions {
  display: flex;
  flex-flow: row wrap;
  gap: calc(var(--mantine-spacing-xs) * 0.5);
}

.option-button {
  /* background: var(--mantine-color-dark-5); */
  box-shadow:
    0 0 1.4rem 0 transparent,
    inset 0 0 2rem 0 var(--mantine-color-dark-9);
  animation: action-pulse 8s ease-out infinite;
  animation-delay: calc(1s * var(--index));
}

@keyframes action-pulse {
  0%,
  100% {
    /* box-shadow: initial; */
    /* background: var(--mantine-color-dark-5); */
  }
  20% {
    box-shadow:
      0 0 1.4rem 0 alpha(var(--mantine-color-dark-4), 0.3),
      inset 0 0 2rem 0 var(--mantine-color-dark-3);
    /* background: color-mix(in oklab, var(--mantine-color-dark-4), var(--mantine-color-dark-5) 20%); */
  }
}

@keyframes glint-sweep {
  0% {
    background-position: 200% 100%;
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    background-position: 0% 0%;
    opacity: 0;
  }
}
